<template>
    <BaseContainer>
        <span slot="principal">
            <v-content class="pr-2 pl-2">
                <v-toolbar class="ma-2" style="border-radius: 30px;">
                    <v-btn icon link to="/">
                        <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                    <v-spacer/>
                    <v-toolbar-title>E-mail</v-toolbar-title>
                    <v-spacer/>
                    <template v-if="$vuetify.breakpoint.mdAndUp">
                        <div class="mr-2">
                            <input
                                v-model="periodo.start"
                                type="date"
                                class="native-input"
                                :max="periodo.end || undefined"
                                @change="onFilterChange"
                            />
                        </div>

                        <div class="mr-3">
                            <input
                                v-model="periodo.end"
                                type="date"
                                class="native-input"
                                :min="periodo.start || undefined"
                                @change="onFilterChange"
                            />
                        </div>

                        <v-select
                            v-model="planFilter"
                            :items="planOptions"
                            :loading="plansLoading"
                            item-text="text"
                            item-value="value"
                            placeholder="Planos"
                            outlined
                            dense
                            hide-details
                            multiple
                            small-chips
                            clearable
                            class="white-and-shadow mr-2"
                            style="width: 260px;"
                            @change="onFilterChange"
                        >
                            <template v-slot:selection="{ item, index }">
                                <v-chip v-if="index === 0" x-small>
                                <span>{{ item.text }}</span>
                                </v-chip>
                                <span v-if="index === 1" class="grey--text text-caption">
                                (+{{ planFilter.length - 1 }} outros)
                                </span>
                            </template>
                        </v-select>

                        <v-btn color="primary" class="white-and-shadow" rounded @click="openEmailDialog">
                            <v-icon left>mdi-email</v-icon>
                            Enviar Email
                        </v-btn>
                    </template>

                    <template v-else>
                        <v-menu
                            v-model="filtersMenu"
                            offset-y
                            :close-on-content-click="false"
                            max-width="360"
                            min-width="320"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on" class="mr-1">
                                    <v-icon>mdi-filter-variant</v-icon>
                                </v-btn>
                            </template>

                            <v-card>
                                <v-card-title class="py-2">
                                    <span>Filtros</span>
                                    <v-spacer/>
                                    <v-btn icon @click="filtersMenu = false">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </v-card-title>

                                <v-divider/>

                                <v-card-text class="pt-3">
                                    <div class="mb-2 grey--text text--darken-1">Cadastro</div>

                                    <div class="d-flex mb-3" style="gap: 8px;">
                                        <input
                                            v-model="periodo.start"
                                            type="date"
                                            class="native-input native-input--full"
                                            :max="periodo.end || undefined"
                                            @change="onFilterChange"
                                        />
                                        <input
                                            v-model="periodo.end"
                                            type="date"
                                            class="native-input native-input--full"
                                            :min="periodo.start || undefined"
                                            @change="onFilterChange"
                                        />
                                    </div>

                                    <v-select
                                        v-model="planFilter"
                                        :items="planOptions"
                                        :loading="plansLoading"
                                        item-text="text"
                                        item-value="value"
                                        placeholder="Planos"
                                        outlined
                                        dense
                                        hide-details
                                        multiple
                                        small-chips
                                        clearable
                                        class="white-and-shadow mb-3"
                                        @change="onFilterChange"
                                    />
                                </v-card-text>

                                <v-card-actions>
                                    <v-btn text @click="clearAllFilters">Limpar</v-btn>
                                    <v-spacer/>
                                    <v-btn color="primary" @click="filtersMenu = false">Fechar</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-menu>

                        <v-btn icon color="primary" @click="openEmailDialog">
                            <v-icon>mdi-email-send</v-icon>
                        </v-btn>
                    </template>
                </v-toolbar>

                <v-card elevation="2" class="ma-1">
                    <v-card-text>
                        <v-data-table
                            v-model="selected"
                            show-select
                            item-key="id"
                            fixed-header
                            :headers="headers"
                            :items="dados"
                            :mobileBreakpoint="0"
                            :loading="loading"
                            :height="$vuetify.breakpoint.height - 230"
                            :disable-pagination="true"
                            :hide-default-footer="true"
                        >
                            <template v-slot:item.database="{ item }">
                                {{ `emp_${item.database}` }}
                            </template>

                            <template v-slot:item.email="{ item }">
                                <span class="text--secondary">{{ item.email || '-' }}</span>
                            </template>

                            <template v-slot:item.assinatura_vencimento_efi="{ item }">
                                {{ item.assinatura_vencimento_efi ? formatDate(item.assinatura_vencimento_efi, 'DD') : '-' }}
                            </template>

                            <template v-slot:item.whatsapp="{ item }">
                                <div @click="copyWhatsapp(item.whatsapp)" style="cursor: pointer;">
                                    <v-icon color="primary" small>mdi-content-copy</v-icon>&nbsp;
                                    <u>{{ item.whatsapp }}</u>
                                </div>
                            </template>

                            <template v-slot:item.created_at="{ item }">
                                {{ formatDate(item.created_at) }}
                            </template>

                            <template v-slot:item.ativo="{ item }">
                                <v-chip class="ma-2" :color="item.ativo ? 'green' : 'red'" text-color="white">
                                    {{ item.ativo ? 'Ativo' : 'Inativo' }}
                                </v-chip>
                            </template>

                            <template v-slot:item.assinatura_emissao="{ item }">
                                {{ formatDate(item.assinatura_emissao) }}
                            </template>
                        </v-data-table>

                        <Paginate v-model="pagination" @input="consultar"/>
                    </v-card-text>
                </v-card>

                <v-dialog v-model="emailDialog" max-width="700">
                    <v-card>
                        <v-card-title class="d-flex align-center">
                            <span>Enviar Email</span>
                            <v-spacer/>
                            <v-btn icon @click="emailDialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-card-title>

                        <v-card-text>
                            <div class="d-flex align-center mb-4" style="gap: 8px;">
                                <v-text-field
                                    v-model="newRecipientName"
                                    outlined
                                    dense
                                    hide-details
                                    placeholder="Nome (opcional)"
                                    style="flex: 1;"
                                />
                                <v-text-field
                                    v-model="newRecipientEmail"
                                    outlined
                                    dense
                                    hide-details
                                    placeholder="email@dominio.com"
                                    style="flex: 1.2;"
                                />
                                <v-btn color="primary" depressed @click="addRecipient">
                                    <v-icon left>mdi-plus</v-icon>
                                    Adicionar
                                </v-btn>
                            </div>

                            <v-card outlined class="mb-4" style="border-radius: 12px;">
                                <v-card-text class="py-2">
                                    <div v-if="!recipientList.length" class="grey--text text--darken-1">
                                        Nenhum destinatário na lista.
                                    </div>

                                    <div
                                        v-for="(r, idx) in recipientList"
                                        :key="`${r.id}-${idx}`"
                                        class="d-flex align-center py-2"
                                        style="gap: 10px;"
                                    >
                                        <div style="min-width: 220px; max-width: 220px;" class="text-truncate">
                                            <strong>{{ r.fantasia }}</strong>
                                        </div>

                                        <v-text-field
                                            v-model="r.email"
                                            outlined
                                            dense
                                            hide-details
                                            placeholder="email@dominio.com"
                                            style="flex: 1;"
                                        />

                                        <v-btn icon color="red" @click="removeRecipient(idx)">
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </div>
                                </v-card-text>
                            </v-card>

                            <v-text-field
                                v-model="subject"
                                outlined
                                placeholder="Título do Email"
                                hide-details
                                class="mb-4"
                            />
                            <v-textarea
                                v-model="message"
                                outlined
                                auto-grow
                                rows="6"
                                placeholder="Digite aqui a mensagem..."
                                hide-details
                            />
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer/>
                            <v-btn text @click="emailDialog = false">Cancelar</v-btn>
                            <v-btn color="primary" :disabled="!message" @click="sendEmail" :loading="sendingEmail">
                                <v-icon left>mdi-send</v-icon>
                                Enviar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-content>
        </span>
    </BaseContainer>
</template>

<script>
import BaseContainer from '@/components/BaseContainer';
import Paginate from '@/components/Paginate';

export default {
    name: 'Email',

    components: {
        Paginate,
        BaseContainer,
    },

    data: () => ({
        search: '',
        loading: false,
        dados: [],
        pagination: {
            current_page: 1,
            last_page: 1,
            total: 0,
        },

        periodo: {
            start: null, // yyyy-mm-dd
            end: null,   // yyyy-mm-dd
        },

        planFilter: [],
        planOptions: [],
        plansLoading: false,

        filtersMenu: false,

        emailDialog: false,
        sendingEmail: false,
        subject: '',
        message: '',

        selected: [],
        recipients: '',

        recipientList: [], // [{ id, fantasia, email }]
        newRecipientEmail: '',
        newRecipientName: '',

        headers: [
            { text: 'ID', value: 'id' },
            { text: 'DB', value: 'database' },
            { text: 'Razao Social', value: 'razao_social' },
            { text: 'Whatsapp', value: 'whatsapp' },
            { text: 'Email', value: 'email' },
            { text: 'Vencimento', value: 'assinatura_vencimento_efi' },
            { text: 'Cadastro', value: 'created_at' },
            { text: 'Status', value: 'ativo' },
            { text: 'Ass. Emissão', value: 'assinatura_emissao' },
            { text: '', value: 'action', sortable: false, align: 'end'},
        ],
    }),

    created() {
        this.loadPlans();
        this.consultar();
    },

    methods: {
        onFilterChange() {
            this.pagination.current_page = 1;
            this.consultar();
        },

        getParams() {
            const params = new URLSearchParams();

            params.append('filters[]', 'assinantes');
            params.append('page', this.pagination.current_page);
            params.append('with_email', '1');
            params.append('with_due', '1');

            if (this.periodo?.start) params.append('start', this.periodo.start);
            if (this.periodo?.end) params.append('end', this.periodo.end);

            if (this.filter?.length) {
                this.filter.forEach(f => params.append('filters[]', f));
            }

            if (this.planFilter?.length) {
                this.planFilter.forEach(p => params.append('plans[]', p));
            }

            return params.toString();
        },

        consultar() {
            this.loading = true;
            this.dados = [];
            this.selected = [];

            const params = this.getParams();

            this.$http.get(`empresas?${params}`)
                .then(resp => {
                    this.pagination = resp.data.meta;
                    this.dados = resp.data.data;
                })
                .catch(() => {
                    this.notify('Não foi possivel concluir a operação', 'warning');
                })
                .finally(() => (this.loading = false));
        },

        loadPlans() {
            this.plansLoading = true;

            this.$http.post('empresa/get-planos')
                .then(resp => {
                    const list = resp.data?.data || resp.data || [];
                    this.planOptions = list.map(p => ({
                        value: p.id,
                        text: `${p.name} | R$${this.formatPrice(p.value / 100)}`,
                    }));
                })
                .catch(() => {
                    this.planOptions = [];
                    this.notify('Não foi possível carregar os planos', 'warning');
                })
                .finally(() => (this.plansLoading = false));
        },

        openEmailDialog() {
            if (!this.selected?.length) {
                this.notify('Selecione pelo menos uma empresa.', 'warning');
                return;
            }

            const list = this.selected.map(e => ({
                id: e.id,
                fantasia: e.fantasia || `Empresa ${e.id}`,
                email: (e.email || '').trim(),
            }));

            const filtered = list.filter(r => !!r.email);

            const seen = new Set();
            this.recipientList = filtered.filter(r => {
                const key = r.email.toLowerCase();
                if (seen.has(key)) return false;
                seen.add(key);
                return true;
            });

            if (!this.recipientList.length) {
                this.notify('Nenhum email encontrado nas empresas selecionadas. Você pode adicionar manualmente.', 'warning');
            }

            this.emailDialog = true;
        },

        async sendEmail() {
            if (!this.subject || !this.message) {
                this.notify('Preencha assunto e mensagem.', 'warning');
                return;
            }

            const emails = this.buildEmailsString();
            if (!emails) {
                this.notify('Adicione ao menos 1 email na lista.', 'warning');
                return;
            }

            this.sendingEmail = true;

            try {
                const payload = {
                    subject: this.subject,
                    message: this.message,
                    empresa_ids: this.selected.map(e => e.id),
                    emails,
                };

                const { data } = await this.$http.post('empresas/send-email', payload);

                const total = data?.total ?? 0;
                const msg = data?.message || `Envio enfileirado para ${total} emails.`;

                this.notify(msg, 'success');

                this.emailDialog = false;
                this.subject = '';
                this.message = '';
                this.recipientList = [];
                this.selected = [];
            } catch (e) {
                const msg =
                e?.response?.data?.message ||
                    'Não foi possível enviar o email.';

                this.notify(msg, 'warning');
            } finally {
                this.sendingEmail = false;
            }
        },

        clearAllFilters() {
            this.periodo.start = null;
            this.periodo.end = null;
            this.planFilter = [];
            this.filter = null;
            this.onFilterChange();
        },

        addRecipient() {
            const email = (this.newRecipientEmail || '').trim();
            if (!email) {
                this.notify('Informe um email para adicionar.', 'warning');
                return;
            }

            const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
            if (!ok) {
                this.notify('Email inválido.', 'warning');
                return;
            }

            const fantasia = (this.newRecipientName || '').trim() || 'Avulso';

            const exists = this.recipientList.some(r => (r.email || '').trim().toLowerCase() === email.toLowerCase());
            if (exists) {
                this.notify('Esse email já está na lista.', 'warning');
                return;
            }

            this.recipientList.unshift({
                id: 0,
                fantasia,
                email,
            });

            this.newRecipientEmail = '';
            this.newRecipientName = '';
        },

        removeRecipient(idx) {
            this.recipientList.splice(idx, 1);
        },

        buildEmailsString() {
            const emails = this.recipientList
                .map(r => (r.email || '').trim())
                .filter(Boolean);

            const unique = [...new Set(emails.map(e => e.toLowerCase()))];
            const mapFirst = new Map();
            emails.forEach(e => {
                const k = e.toLowerCase();
                if (!mapFirst.has(k)) mapFirst.set(k, e);
            });

            return unique.map(k => mapFirst.get(k)).join(', ');
        },

        closeEmailDialog() {
            this.emailDialog = false;
            this.newRecipientEmail = '';
            this.newRecipientName = '';
        },
    },
}
</script>

<style scoped>
.native-input {
    height: 40px;
    width: 160px;
    padding: 0 12px;
    border: 1px solid rgba(0,0,0,0.12);
    border-radius: 8px;
    outline: none;
    background: #fff;
    box-shadow: 0 2px 10px rgba(0,0,0,0.05);
    font-size: 14px;
}

.native-input:focus {
    border-color: rgba(25, 118, 210, 0.6);
}

.native-input--full {
    width: 100%;
}
</style>
